module.exports = {
      id: "photo-usage",
      viewBox: "0 0 12 9",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#photo",
      toString: function () {
        return this.url;
      }
    }